import contents from '../routes/contentRoutes';

export const useRoleBasedRoutes = () => contents;
